"use client";

import React from "react";
import { motion } from "framer-motion";
import { confirmPayService } from "@/src/features/listing/confirmPay";

interface IPriceBreakdownSheetProps {
  nightsLabel: string;
  nights: number;
  totals: { base: number; total: number; discount: number };
  onClose: () => void;
}

/** The app's `PriceBreakdownSheet`: nights, the stay discount and the total. */
const PriceBreakdownSheet: React.FC<IPriceBreakdownSheetProps> = ({
  nightsLabel,
  nights,
  totals,
  onClose,
}) => (
  <>
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
      className="fixed inset-0 z-[55] bg-black/40 md:hidden"
    />
    <motion.div
      initial={{ y: "100%" }}
      animate={{ y: 0 }}
      exit={{ y: "100%" }}
      transition={{ type: "spring", damping: 30, stiffness: 300 }}
      role="dialog"
      aria-modal
      aria-label="Price breakdown"
      className="fixed inset-x-0 bottom-0 z-[60] rounded-t-3xl bg-white px-4 pb-[max(24px,env(safe-area-inset-bottom))] md:hidden"
    >
      <div className="flex h-14 items-center border-b border-[#EBEBEB] px-4">
        <span className="w-8" />
        <h2 className="flex-1 text-center text-15 font-semibold leading-6 text-ink">
          Price breakdown
        </h2>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="flex h-8 w-8 items-center justify-center rounded-full bg-[#F7F7F7]"
        >
          <img
            src="/icons/confirm-pay/calendars_close_icon.svg"
            alt=""
            className="h-[18px] w-[18px]"
          />
        </button>
      </div>
      <div className="flex items-center justify-between py-2 text-16 leading-6 text-ink">
        <span>{nightsLabel}</span>
        <span>{confirmPayService.taka(totals.base)}</span>
      </div>
      {totals.discount > 0 && (
        <>
          <div className="flex h-[49px] items-center justify-between text-16 leading-6 text-ink">
            <span>{confirmPayService.discountLabel(nights)}</span>
            <span className="text-success-earn">
              -{confirmPayService.taka(totals.discount)}
            </span>
          </div>
          <p className="h-6 text-12 font-medium leading-4 text-ink-secondary">
            {confirmPayService.discountNote(nights)}
          </p>
        </>
      )}
      <div className="flex items-center justify-between border-t border-[#EBEBEB] py-4 text-16 font-medium leading-6 text-ink">
        <span>Total BDT</span>
        <span>{confirmPayService.taka(totals.total)}</span>
      </div>
    </motion.div>
  </>
);

export default PriceBreakdownSheet;
